function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { Component } from 'react';
import * as d3 from 'd3';
import BarChart from './BarChart';
export var BarChartYear = /*#__PURE__*/function (_Component) {
  _inheritsLoose(BarChartYear, _Component);

  function BarChartYear(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.calcDomain = _this.calcDomain.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = BarChartYear.prototype;

  _proto.calcDomain = function calcDomain(chart) {
    var nullv = new Date(null),
        filtered = chart.group().all().filter(function (v) {
      return v.key > nullv;
    }),
        min = d3.min(filtered, function (kv) {
      return kv.key;
    }),
        max = d3.max(filtered, function (kv) {
      return kv.key;
    });
    max = d3.timeYear.offset(max, 1);
    chart.x().domain([min, max]);
  };

  _proto.render = function render() {
    return /*#__PURE__*/React.createElement(BarChart, _extends({
      id: this.props.id,
      x: d3.scaleTime(),
      xUnits: d3.timeYears,
      round: d3.timeYear.round,
      preRender: this.calcDomain,
      preRedraw: this.calcDomain,
      elasticX: false
    }, this.props));
  };

  return BarChartYear;
}(Component);
export default BarChartYear;